import fetch, { growthFetch } from '@/utils/fetch';

// 统一处理请求参数
export const filterURLSearchParams = (args = {}) => {
    const params = new URLSearchParams();
    Object.keys(args).forEach(key => {
        params.append(key, args[key]);
    })
    return params;
}

// 查询组件库列表
export const getGrowthBookAssemblyList = data =>
    growthFetch({
        url: 'structure/growthBook/getGrowthBookAssemblyList',
        method: 'POST',
        data: filterURLSearchParams(data)
    })

// 新增成长册组件库
export const addGrowthBookAssembly = data =>
    growthFetch({
        url: 'structure/growthBook/addGrowthBookAssembly',
        method: 'POST',
        data: filterURLSearchParams(data)
    })

// 编辑成长册组件库
export const editGrowthBookAssembly = data =>
    growthFetch({
        url: 'structure/growthBook/editGrowthBookAssembly',
        method: 'POST',
        data: filterURLSearchParams(data)
    })

// 删除成长册组件库
export const deleteGrowthBookAssemblyById = data =>
    growthFetch({
        url: 'structure/growthBook/deleteGrowthBookAssemblyById',
        method: 'POST',
        data: filterURLSearchParams(data)
    })

// 查询组件库详细信息
export const getGrowthBookAssemblyInfoById = data =>
    growthFetch({
        url: 'structure/growthBook/getGrowthBookAssemblyInfoById',
        method: 'POST',
        data: filterURLSearchParams(data)
    })



// WEBPACK FOOTER //
// ./src/api/growthBook.js